import { ComponentType } from '@angular/cdk/portal';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';

import { SnackbarComponent, SnackbarDataType } from './snackbar.component';
import { SnackbarType } from './snackbar-config';

@Injectable({ providedIn: 'root' })
export class TiimeSnackbarService {
  private readonly matSnackbar = inject(MatSnackBar);

  open(
    message: string,
    config: Partial<MatSnackBarConfig<Partial<SnackbarDataType>>>,
    actionButtonText?: string
  ): MatSnackBarRef<SnackbarComponent> {
    const snackbarType: SnackbarType | undefined = config.data?.type;
    return this.matSnackbar.openFromComponent(SnackbarComponent, {
      ...config,
      data: { message, type: snackbarType, actionButtonText }
    });
  }

  openFromComponent<T, D = unknown>(component: ComponentType<T>, config?: MatSnackBarConfig<D>): MatSnackBarRef<T> {
    return this.matSnackbar.openFromComponent(component, config);
  }
}
